var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalConnecter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    rx: 8,
    fill: "#8F79FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.75C8.0375 20.75 7.85938 20.6781 7.71563 20.5344C7.57188 20.3906 7.5 20.2125 7.5 20V19.25H6.75V16.25C6.75 16.0375 6.82188 15.8594 6.96563 15.7156C7.10938 15.5719 7.2875 15.5 7.5 15.5H8.25V10.25C8.25 9.425 8.54375 8.71875 9.13125 8.13125C9.71875 7.54375 10.425 7.25 11.25 7.25C12.075 7.25 12.7812 7.54375 13.3688 8.13125C13.9563 8.71875 14.25 9.425 14.25 10.25V17.75C14.25 18.1625 14.3969 18.5156 14.6906 18.8094C14.9844 19.1031 15.3375 19.25 15.75 19.25C16.1625 19.25 16.5156 19.1031 16.8094 18.8094C17.1031 18.5156 17.25 18.1625 17.25 17.75V12.5H16.5C16.2875 12.5 16.1094 12.4281 15.9656 12.2844C15.8219 12.1406 15.75 11.9625 15.75 11.75V8.75H16.5V8C16.5 7.7875 16.5719 7.60938 16.7156 7.46563C16.8594 7.32188 17.0375 7.25 17.25 7.25H18.75C18.9625 7.25 19.1406 7.32188 19.2844 7.46563C19.4281 7.60938 19.5 7.7875 19.5 8V8.75H20.25V11.75C20.25 11.9625 20.1781 12.1406 20.0344 12.2844C19.8906 12.4281 19.7125 12.5 19.5 12.5H18.75V17.75C18.75 18.575 18.4563 19.2812 17.8688 19.8688C17.2812 20.4563 16.575 20.75 15.75 20.75C14.925 20.75 14.2188 20.4563 13.6313 19.8688C13.0438 19.2812 12.75 18.575 12.75 17.75V10.25C12.75 9.8375 12.6031 9.48438 12.3094 9.19063C12.0156 8.89688 11.6625 8.75 11.25 8.75C10.8375 8.75 10.4844 8.89688 10.1906 9.19063C9.89688 9.48438 9.75 9.8375 9.75 10.25V15.5H10.5C10.7125 15.5 10.8906 15.5719 11.0344 15.7156C11.1781 15.8594 11.25 16.0375 11.25 16.25V19.25H10.5V20C10.5 20.2125 10.4281 20.3906 10.2844 20.5344C10.1406 20.6781 9.9625 20.75 9.75 20.75H8.25Z",
    fill: "#8F79FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalConnecter);
export default __webpack_public_path__ + "static/media/total-connecter.bbc2c00d8f3d0c9579ec03cdf7be5755.svg";
export { ForwardRef as ReactComponent };